module.exports = __webpack_public_path__ + "static/14-2dc213f16180262a133bf517a975b42a.jpg";